import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

@ngCore.Component({
  imports: [
    ds.button.Component,
    ds.input.text.Component,
    ds.overlay.centered.Component,
  ],
  selector: 'atn-add-label-overlay',
  standalone: true,
  styleUrls: ['./add-label-overlay.component.scss'],
  templateUrl: './add-label-overlay.component.html',
})
export class AtnAddLabelOverlayComponent {
  @ngCore.Input({ alias: 'name', required: true })
  public set rawName(name: string) {
    this.name = name
  }

  @ngCore.Input({ alias: 'value' })
  public set rawValue(value: string | undefined) {
    this.value = value
  }

  public name = ''
  public value: string | undefined

  @ngCore.Output()
  public readonly cancel = new ngCore.EventEmitter<void>()
  @ngCore.Output()
  public readonly close = new ngCore.EventEmitter<void>()
  @ngCore.Output()
  public readonly add = new ngCore.EventEmitter<void>()
  @ngCore.Output()
  public readonly backdropClick = new ngCore.EventEmitter<void>()
  @ngCore.Output()
  public readonly labelChange = new ngCore.EventEmitter<string>()
}
